import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';

export const FailurePublishContent = (props) => {
    const { title, error, onClose, appMakerUrl, isShowFromWorkspace, showOkayButton = true } = props

    const goToAppMaker = () => {
        window.open(appMakerUrl, "_blank").focus();
    }

    return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
            <img
                alt='app-failure'
                height={"150rem"}
                src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/PublishingAppFailed.png`}
            />
            <h4 className='mt-2'>{title}</h4>
            {
                error &&
                <div className="text-danger text-center my-4">
                    {error}
                </div>
            }
            {isShowFromWorkspace &&
                <>
                    <p className='font-size-3'>
                        Please go to App Maker to check the reason why it is failed or try exploring other from the{" "}
                        <span onClick={onClose} className="text-primary cursor-pointer">
                            App Library
                        </span>.
                    </p>
                    <button onClick={goToAppMaker} className="btn btn-primary font-size-2">
                        Go to App Maker
                    </button>
                </>
            }
            {(!isShowFromWorkspace && showOkayButton) &&
                <button className='btn btn-primary rounded-pill font-size-1 my-4' onClick={onClose}>
                    Okay
                </button>
            }
        </div>
    )
}

const FailurePublishDialog = (props) => {
    return (
        <Dialog
            title=" "
            onClose={props.onClose}
            width="30%"
        >
            <FailurePublishContent {...props} />
        </Dialog>
    )
}

export default FailurePublishDialog